import { TabType } from '@/routes/dashboards/shared-types';

import { formatCurrency, formatMetric } from '@/utils/format-utils';

export const tickFormatter = (value: number, initialTab: TabType) => {
  switch (initialTab) {
    case 'revenue':
    case 'directRevenue':
    case 'influencedRevenue':
      return formatCurrency(value, 0);
    default:
      return formatMetric(value, 0);
  }
};
